export const pt = {
  // Certificate Headers
  congrats_message: "A sua instalação de WiFi está completa e foi certificada pela RouteThis!",
  installation_details: "Detalhes da Instalação",
  wireless_speed_test: "Teste de Velocidade Sem Fios",
  wireless_performance: "Wireless Performance",
  photos: "Fotos",
  signal_maps: "Mapas de Sinal",

  // Certificate Room Names
  singular_room: "Divisão",
  room_type_bathroom: "Casa de Banho",
  room_type_bedroom: "Quarto",
  room_type_dining_room: "Sala de Jantar",
  room_type_entry_or_hall: "Entrada/Hall",
  room_type_garage: "Garagem",
  room_type_kitchen: "Cozinha",
  room_type_living_room: "Sala de Estar",
  room_type_office: "Escritório",
  room_type_other: "Outro",

  // Pod Name
  pod_1: "Nó de Rede",
  pod_2: "Ponto de Acesso",
  pod_3: "Nó de Rede",
  pod_4: "Nó de Rede",
  pod_5: "Nó",
  pod_6: "Nó de Rede",
  pods_1: "Nós de Rede",
  pods_2: "Pontos de Acesso",
  pods_3: "Nós de Rede",
  pods_4: "Nós de Rede",
  pods_5: "Nós",
  pods_6: "Nós de Rede",

  // Router Name
  router_1: "Router",
  router_2: "Modem",
  router_3: "Gateway",
  router_4: "Hub",
  router_5: "Router",

  // Level Name
  level_1: "Piso",
  level_2: "Andar",
  levels_1: "Pisos",
  levels_2: "Andares",

  // Certificate Pod Info
  recommended: "Recomendado",
  installed: "Instalado",
  total: "Total",

  // Certificate Signal Table
  front_building: "Frente do Edifício",
  speed: "Veloc.",
  video: "Vídeo",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Lig.",
  frequency_short: "Freq.",
  frequency_description: "MHz",
  channel_short: "Can.",

  // Certificate Legend
  legend: "Lenda",
  measured_speed: "Velocidade Medida",
  measured_speed_description: "Mbps",

  // Certificate Speedtest Result
  speedtest_passed: "A velocidade está dentro da gama esperada para a maior parte dos dispositivos móveis. Nem todos os dispositivos sem fios são capazes de alcançar a velocidade máxima do plano. Veja em baixo os testes individuais de divisões.",
  speedtest_failed: "Testado no seu telemóvel ou tablet. Nem todos os dispositivos sem fios são capazes de alcançar a velocidade máxima do plano. Veja em baixo os testes individuais de divisões.",
}